import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { ContactType } from "../../../../api/firebase/types/contact.types";
import { ContactOption } from "../../../../api/firebase/types/scenario.types";
import ContactOptionTable from "../../../../components/table/ContactOptionTable";
import ContactSelectionModalStore from "../../../../store/ContactSelectionModalStore";
import ContactStore from "../../../../store/ContactStore";
import DeviceStore from "../../../../store/DeviceStore";
import ContactService from "../../../../util/ContactService";

type DeviceContactOptionTableProps = {
  contactSettings?: Map<ContactOption, string[]>;
  onChange: (contactSettings: Map<ContactOption, string[]>) => void;
};

const DeviceContactOptionTable: React.FC<DeviceContactOptionTableProps> = ({
  contactSettings,
  onChange,
}) => {
  const { getContactsById } = ContactStore;
  const { setContactParams } = ContactSelectionModalStore;

  const scenarioContactIds = ContactService.getAllUniqueIds(contactSettings);

  const onContactSelection = (contactIds: string[]) => {
    const newContactSettings = ContactService.processIncomingIds(
      contactIds,
      contactSettings
    );
    DeviceStore.updateCurrentDevice({
      ...DeviceStore.currentDevice,
      contactSettings: newContactSettings,
    });
  };

  return (
    <>
      <Toolbar
        className="p-mt-3"
        left={() => <h3>Meldeinstanz-spezifische Notfallkontakte</h3>}
        right={() => (
          <Button
            type="button"
            label="Kontakte auswählen"
            icon="pi pi-plus"
            className="p-button-text"
            onClick={() =>
              setContactParams(scenarioContactIds, onContactSelection)
            }
          />
        )}
      />
      <ContactOptionTable
        contactSettings={contactSettings || new Map()}
        value={getContactsById(scenarioContactIds)}
        onChange={onChange}
      >
        <Column
          field="name"
          header="Name"
          body={(contact: ContactType) => (
            <div>{`${contact.firstName} ${contact.lastName}`}</div>
          )}
        />
      </ContactOptionTable>
    </>
  );
};

export default DeviceContactOptionTable;
